// Title + CSV/PDF export + refresh, shared by every register view.
//
// The exported filename and PDF heading are both derived from the view's own
// title, which fixes the Task C18 bug where a filtered export still wrote
// "discharged_patients.pdf" titled "Discharged Patients" (the CONTENT was
// filtered correctly; only the labelling lied).

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import { NURSE_COLORS } from "../../../nurse-dashboard/theme";
import { exportCsv, exportPdf } from "./registerUtils";

const buttonSx = {
  color: NURSE_COLORS.primary,
  border: `1px solid ${NURSE_COLORS.border}`,
  borderRadius: 20,
  textTransform: "none",
};

export default function RegisterToolbar({ title, columns, rows, loading, onRefresh }) {
  const filenameBase = title.toLowerCase().replace(/[^a-z0-9]+/g, "_");

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 1 }}>
      <Typography variant="h6" color={NURSE_COLORS.textPrimary}>
        {title}{" "}
        <Typography component="span" variant="body2" color="text.secondary">
          ({rows.length})
        </Typography>
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          startIcon={<DownloadIcon />}
          disabled={rows.length === 0}
          onClick={() => exportCsv(columns, rows, filenameBase)}
          sx={buttonSx}
        >
          Export CSV
        </Button>
        <Button
          startIcon={<PictureAsPdfIcon />}
          disabled={rows.length === 0}
          onClick={() => exportPdf(columns, rows, filenameBase, title)}
          sx={buttonSx}
        >
          Export PDF
        </Button>
        <Button startIcon={<RefreshIcon />} onClick={onRefresh} disabled={loading} sx={buttonSx}>
          Refresh
        </Button>
      </Box>
    </Box>
  );
}
